// extracted by mini-css-extract-plugin
export var alertIcon = "_sz-0";